import axios from "axios";

export const request = axios.create({
  baseURL: "https://muassasa-api.eurosoft.dev/",
  headers: {
    'api-token': "p12378",
  },
});
